import React, {useEffect, useState} from "react";
import {Box, Container, Drawer, FormControl, InputLabel, Paper, Select} from "@mui/material";

import Title from "../Title";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import countryList from "react-select-country-list";
import Button from "@mui/material/Button";
import Api from "../../Services/Api";


const BillingInfoForm = ({form, setForm, setDrawer, setReload}) => {

    const [countries, setCountries] = React.useState([]);

    const [companySelect, setCompanySelect] = useState(form?.company || null);

    const handleOptionChange = (event) => {
        setCompanySelect(event.target.value);
    };



    useEffect(() => {

        setCountries(countryList().getData())

    }, []);

    const handleSubmitBillingInfo = async (event) => {

        event.preventDefault();
        Api.storeBillingInfo(form).then( r => { setDrawer(false); setReload("billing")})
    }

    const handleChangeBillingInfo = (event) => {


        setForm(prevState =>
            ({
                ...prevState,
                [event.target.name]: event.target.value
            })
        )
    };



    return (

        <Box component={"form"} onSubmit={handleSubmitBillingInfo} sx={{ width: 350, p: 2 }}>
            <Title>{!form?.id ? "New Billing Info" : "Billing Info"}</Title>

            {/* Add the select box to choose between 'individual' and 'company' */}
            <FormControl variant="outlined" fullWidth sx={{ mt: 2 }} required={true} disabled={form?.id}>
                <InputLabel id="option">Select</InputLabel>
                <Select
                    labelId="option"
                    id="company"
                    value={companySelect ?? form?.company ?? ''}
                    label="Select"
                    onChange={handleOptionChange}
                >
                    <MenuItem value="0" >
                        Individual
                    </MenuItem>
                    <MenuItem value="1" >
                        Company
                    </MenuItem>
                </Select>
            </FormControl>

            {/* Use conditional rendering to show the appropriate input fields */}
            {(companySelect === '0' || form?.company === 0) && (
                <>
                    <TextField label="First Name" disabled={form?.id} value={form?.first_name} required={true} name="first_name" variant="outlined" onChange={handleChangeBillingInfo} fullWidth margin="normal" />
                    <TextField label="Last Name" disabled={form?.id}  value={form?.last_name} required={true}  name="last_name" variant="outlined" onChange={handleChangeBillingInfo} fullWidth margin="normal" />
                </>
            )}

            {(companySelect === '1' || form?.company === 1)  && (
                <TextField label="Company Name" disabled={form?.id} value={form?.company_name} required={true} name={"company_name"} variant="outlined" onChange={handleChangeBillingInfo} fullWidth margin="normal"/>
            )}
                            <TextField label="Tax ID" value={form?.tax_id} disabled={form?.id}  required={true} name={"tax_id"} variant="outlined" onChange={handleChangeBillingInfo} fullWidth margin="normal"/>
                            <TextField label="Address" value={form?.address} disabled={form?.id}  required={true} name={"address"} variant="outlined"  onChange={handleChangeBillingInfo} fullWidth margin="normal"/>
                            <FormControl variant="outlined" fullWidth={true} sx={{mt: 2}} required={true}>
                                <InputLabel id="country">Country</InputLabel>
                                <Select
                                    labelId="country"
                                    id="country"
                                    name={"country"}
                                    required={true}
                                    disabled={form?.id}
                                    value={form?.country ?? ''}
                                    label="Country"
                                    onChange={handleChangeBillingInfo}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {countries?.map((item, key) => <MenuItem key={key} value={item.value}>{item.label}</MenuItem>)}

                                </Select>
                            </FormControl>
                            <TextField label="State or Region" disabled={form?.id}  value={form?.state} onChange={handleChangeBillingInfo}  name={"state"} variant="outlined" fullWidth margin="normal"/>
                            <TextField label="City" name={"city"} disabled={form?.id}  value={form?.city} onChange={handleChangeBillingInfo} required={true}variant="outlined" fullWidth margin="normal"/>
                            <TextField label="Postal Code" required={true} disabled={form?.id}   value={form?.postal_code} onChange={handleChangeBillingInfo}  name={"postal_code"} variant="outlined" fullWidth margin="normal"/>
                            {!form?.id && <Button variant={'contained'} type={"submit"} fullWidth={true}>Create Billing Info</Button>}
                        </Box>

    )
}


export default BillingInfoForm